// material ui icons
import TrendingDownIcon from '@mui/icons-material/TrendingDown';

// material ui
import { Card, CardContent, Divider, Typography } from '@mui/material';

// api
import { ReadAlarmDto } from '@/api/generated/recalc/endpoints/v1/alarms';

// relative
import AlarmTypeCardHeader from '../AlarmTypeCardHeader';

const MinThresholdExceeded = ({ alarm }: { alarm: ReadAlarmDto }) => {
  console.log('Rendering MinThresholdExceeded with alarm:', alarm);
  return (
    <Card>
      <AlarmTypeCardHeader
        alarm={alarm}
        title="Min Threshold Exceeded"
        avatarIcon={<TrendingDownIcon />}
      />
      <Divider />
      <CardContent>
        <Typography variant="body1">{alarm.Message}</Typography>
      </CardContent>
    </Card>
  );
};

export default MinThresholdExceeded;
